// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    width: 100%;
    max-width: 730px;
    height: 75px;
    margin-bottom: 53px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
}
.oneX-header {
    margin-bottom: 53px;
}
.header-nav {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    align-items: center;
}
.lr-nav-btn {
    background: none;
    border: none;
    display: flex;
    align-items: center;
    color: #6e6e6e;
}
.lr-nav-btn-disabled {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  color: #6e6e6e;
  opacity: 0.4;
}
.lr-progress-btn {
    background: none;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: -16px;
    color: #6e6e6e;
    font-weight: 600;
    line-height: 21px;
    font-size: 14px;
}
.lr-progress-btn-sub {
    color: #6e6e6e;
    font-size: 12px;
    font-weight: 300;
    line-height: 18px;
}
.lr-progress-chev {
    align-self: center;
    margin-left: 6px;
    width: 13px;
    height: 13px;
}

@media(min-width: 768px) {
    .header {
        margin-bottom: 62px;
        height: 96px;
    }
    .oneX-header {
        margin-bottom: 62px;
    }
    .lr-progress-btn {
        font-size: 16px;
        line-height: 24px;
        font-weight: normal;
    }
    .lr-back-icon {
        padding-right: 8px;
    }
    .lr-forward-icon {
      padding-left: 8px;
  }
  .lr-forward-icon-disabled {
    padding-left: 8px;
    opacity: 0.4;
  }
  .lr-back-icon-disabled {
    padding-right: 8px;
    opacity: 0.4;
  }
}

.lr-nav-btn-dimensions {
    width: 24px; 
    height: 16px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/progress/progress.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;MACE,iBAAiB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".header {\n    width: 100%;\n    max-width: 730px;\n    height: 75px;\n    margin-bottom: 53px;\n    font-size: 14px;\n    display: flex;\n    flex-direction: column;\n}\n.oneX-header {\n    margin-bottom: 53px;\n}\n.header-nav {\n    display: flex;\n    justify-content: space-between;\n    flex-grow: 1;\n    align-items: center;\n}\n.lr-nav-btn {\n    background: none;\n    border: none;\n    display: flex;\n    align-items: center;\n    color: #6e6e6e;\n}\n.lr-nav-btn-disabled {\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  color: #6e6e6e;\n  opacity: 0.4;\n}\n.lr-progress-btn {\n    background: none;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-right: -16px;\n    color: #6e6e6e;\n    font-weight: 600;\n    line-height: 21px;\n    font-size: 14px;\n}\n.lr-progress-btn-sub {\n    color: #6e6e6e;\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 18px;\n}\n.lr-progress-chev {\n    align-self: center;\n    margin-left: 6px;\n    width: 13px;\n    height: 13px;\n}\n\n@media(min-width: 768px) {\n    .header {\n        margin-bottom: 62px;\n        height: 96px;\n    }\n    .oneX-header {\n        margin-bottom: 62px;\n    }\n    .lr-progress-btn {\n        font-size: 16px;\n        line-height: 24px;\n        font-weight: normal;\n    }\n    .lr-back-icon {\n        padding-right: 8px;\n    }\n    .lr-forward-icon {\n      padding-left: 8px;\n  }\n  .lr-forward-icon-disabled {\n    padding-left: 8px;\n    opacity: 0.4;\n  }\n  .lr-back-icon-disabled {\n    padding-right: 8px;\n    opacity: 0.4;\n  }\n}\n\n.lr-nav-btn-dimensions {\n    width: 24px; \n    height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
